import { render, staticRenderFns } from "./CpuRelationManagement.vue?vue&type=template&id=37d6c2de&scoped=true"
import script from "./CpuRelationManagement.vue?vue&type=script&lang=js"
export * from "./CpuRelationManagement.vue?vue&type=script&lang=js"
import style0 from "./CpuRelationManagement.vue?vue&type=style&index=0&id=37d6c2de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d6c2de",
  null
  
)

export default component.exports